import React from "react";
import CurrencyFormat from "react-currency-format";
import { CheckOutlined, CloseOutlined, FileProtectOutlined, RightOutlined, WarningOutlined } from "@ant-design/icons";
import { Tag } from "antd";

function Fact({ children }) {
  if (children == null || children === "") return null;
  return <span className="listing-card__fact">{children}</span>;
}

export function PlanListingCard({ record, onClick }) {
  const active = Number(record?.plan_status) === 1;
  const hasTier = record?.tier_id != null && record?.tier_id !== "";
  const tierLabel = record?.tier_name || (hasTier ? `Tier ${record.tier_id}` : null);
  const planType = record?.plans_types_name || record?.plan_type_name;

  return (
    <article
      className="listing-card listing-card--linear plan-listing-card"
      onClick={onClick}
      onKeyDown={onClick ? (e) => e.key === "Enter" && onClick() : undefined}
      role={onClick ? "button" : undefined}
      tabIndex={onClick ? 0 : undefined}
    >
      <div className="listing-card__lead">
        <div className="listing-card__icon is-plan" aria-hidden>
          <FileProtectOutlined />
        </div>
        <div className="listing-card__identity">
          <h3 className="listing-card__title">{record?.plan_name || "—"}</h3>
          <p className="listing-card__meta">{planType || "Insurance plan"}</p>
        </div>
      </div>

      <div className="listing-card__facts">
        {hasTier ? (
          <Fact><Tag color="blue">{tierLabel}</Tag></Fact>
        ) : (
          <Fact><Tag color="orange" icon={<WarningOutlined />}>Unassigned tier</Tag></Fact>
        )}
        <Fact>
          <CurrencyFormat value={record?.plan_cost || 0} displayType="text" thousandSeparator prefix="₦" />
          {" unit"}
        </Fact>
        <Fact>
          <CurrencyFormat value={record?.plan_six_cost || 0} displayType="text" thousandSeparator prefix="₦" />
          {" family"}
        </Fact>
        {record?.plan_description ? <Fact>{record.plan_description}</Fact> : null}
      </div>

      <div className="listing-card__aside">
        <span className={`listing-card__status ${active ? "is-active" : "is-inactive"}`}>
          {active ? <CheckOutlined /> : <CloseOutlined />}
          {active ? "Active" : "Inactive"}
        </span>
        {onClick ? <RightOutlined className="listing-card__chevron" aria-hidden /> : null}
      </div>
    </article>
  );
}

export default PlanListingCard;
